import { Button } from "@/components/ui/button";
import { BUTTONS } from "@/utils/constants/appConstants/commonConstants";
import { NO_ACTIVITY_IN_DATE_RANGE } from "@/utils/constants/messages";

interface NoFilterDataCardProps {
    loadAll: () => void;
    id: string;
}

const NoFilterDataCard: React.FC<NoFilterDataCardProps> = (props) => {
    return (
        <div className="no-filter-data-container">
            <em id={`${props.id}-no-filter-data-icon`} className="icon ni ni-file no-filter-data-icon" />
            <div className="emptyState_text">
                <div id={`${props.id}-no-filter-result`}>{NO_ACTIVITY_IN_DATE_RANGE}</div>
            </div>
            <Button id={`${props.id}-load-all-data-btn`} onClick={props.loadAll} type="button" variant="light">
                {BUTTONS.LOAD_ALL}
            </Button>
        </div>
    );
};

export default NoFilterDataCard;
